import LottieFromUrl from "../../../../components/LottieFromUrl/LottieFromUrl";
import WebShadowButton from "../../../WebStoryScreen/Components/WebShadowButton";
import {
  BreatheContent,
  BreatheEmoji,
} from "../../../../hooks/useRetrieveBreatheExercise";
import "./EmojiContent.scss";
import { trackEvent } from "../../../../../mixpanel";
import { TrackingEvents } from "../../../../Utilities/analytics";

function EmojiItem({
  emoji,
  selected,
  onSelect,
}: {
  emoji: BreatheEmoji;
  selected: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      className={`emoji-content__emoji-btn${selected ? " emoji-content__emoji-btn--selected" : ""}`}
      onClick={onSelect}
      aria-label={`Emoji ${emoji.linkTo}`}
    >
      <LottieFromUrl
        url={emoji.image}
        className="emoji-content__emoji-lottie"
      />
    </button>
  );
}

interface EmojiContentProps {
  breatheContent: BreatheContent;
  selectedEmoji: string | null;
  setSelectedEmoji: (v: string | null) => void;
  onDone: () => void;
}

function EmojiContent({
  breatheContent,
  selectedEmoji,
  setSelectedEmoji,
  onDone,
}: EmojiContentProps) {
  const { title, emojis } = breatheContent.userAction ?? {};

  return (
    <div className="emoji-content">
      <p className="emoji-content__title">{title}</p>
      <div className="emoji-content__row">
        {emojis?.map((emoji) => (
          <EmojiItem
            key={emoji.linkTo}
            emoji={emoji}
            selected={selectedEmoji === emoji.linkTo}
            onSelect={() => setSelectedEmoji(emoji.linkTo)}
          />
        ))}
      </div>
      <div className="emoji-content__done-wrap">
        <WebShadowButton
          style={{ width: "90%" }}
          title="Done!"
          disabled={!selectedEmoji}
          onPress={() => {
            trackEvent(TrackingEvents.calm_corner_feeling_feedback, {
              emoji_selected: selectedEmoji,
            });
            onDone();
          }}
        />
      </div>
    </div>
  );
}

export default EmojiContent;
